<template>
  <div>
    <div v-if="user != null">
      <userCommentsItemVue
        :props_userLogoBig="user.userLogoBig"
        @submitComment="submitComment"
      ></userCommentsItemVue>
    </div>
    <div>
      <div v-for="item in commentList" :key="item.id">
        <hr class="divider" />
        <div class="flex-container1">
          <div>
            <img
              class="flex-item img-rounded"
              :src="item.sgL_ImageLogin"
              width="60"
              height="60"
              :onerror="$defaultUserLog"
            />
          </div>
          <div class="flex-container2">
            <div class="userName">
              {{ item.sgL_Mem_DisplayName }} &nbsp;&nbsp;{{
                item.sgL_My_Receive_MViewTimersF
              }}
            </div>
            <div class="userContent">
              {{ item.sgL_Msg_MContent }}
              <deleteCommentVue
                :commentId="item.id"
                :authId="item.sgL_Mem_Cid"
                @delSuccess="getComments"
              ></deleteCommentVue>
            </div>
            <div v-if="item.messageDto == null">
              <a
                href="javascript:void(0);"
                class="userReply"
                @click="changeReplyId(item.id, item.sgL_Mem_Cid)"
                >> 0 {{$t('common.userComments.message')}}</a
              >
            </div>
            <div v-else>
              <a
                href="javascript:void(0);"
                @click="changeReplyId(item.id, item.sgL_Mem_Cid)"
                class="userReply"
                >> {{ item.messageDto.length }} {{$t('common.userComments.message')}}</a
              >
              <div v-for="item2 in item.messageDto">
                <div class="flex-container1">
                  <div>
                    <img
                      class="flex-item img-rounded"
                      :src="item2.sgL_ImageLogin"
                      width="60"
                      height="60"
                    />
                  </div>
                  <div class="flex-container2">
                    <div class="userName">
                      {{ item2.sgL_Mem_DisplayName }} &nbsp;&nbsp;{{
                        item2.sgL_My_Receive_MViewTimersF
                      }}
                    </div>
                    <div class="userContent">
                      {{ item2.sgL_Msg_MContent }}
                      <deleteCommentVue
                        :commentId="item2.id"
                        :authId="item2.sgL_Mem_Cid"
                        @delSuccess="getComments"
                      ></deleteCommentVue>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="replyId == item.id">
              <userCommentsItemVue
                v-if="user != null"
                :props_userLogoBig="user.userLogoBig"
                @submitComment="submitComment2"
              ></userCommentsItemVue>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import deleteCommentVue from "./deleteComment.vue";
import userCommentsItemVue from "./userCommentsItem.vue";
export default {
  name:'userComments',
  components: {
    userCommentsItemVue,
    deleteCommentVue,
  },
  data() {
    return {
      commentList: null,
      commentText: "",
      replyId: -1,
      sgL_Mem_Cid: -1,
      user: null,
    };
  },
  props: {
    props_qryParams: { Type: Object, default: null, required: false },
  },
  created() {
    this.user = this.$store.getters.getcustomer;
    this.getComments();
  },
  methods: {
    getComments(isReturnCount, callParams) {
      this.replyId = -1;
      let params = this.props_qryParams;
      if (callParams) {
        params = callParams;
      }
      if (!params) {
        return;
      }
      this.$api.albumApi.getMessageByTypeId(params).then((res) => {
        if (res.data.success) {
          this.commentList = res.data.result.items;
          if (isReturnCount) {
            this.$emit("allCommentCount", res.data.result.totalCount);
          }
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    submit(params, qryParams) {
      this.$api.albumApi.createMessage(params).then((res) => {
        if (res.data.success) {
          this.getComments(true, qryParams);
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
    submitComment(data) {
      this.$emit("submitComment", data);
    },
    submitComment2(data) {
      this.$emit(
        "submitComment2",
        data,
        this.replyId,
        this.sgL_Mem_Cid,
        this.sgL_Mem_Cid
      );
    },
    changeReplyId(id, sgL_Mem_Cid) {
      if (this.user == null) {
        this.$router.push({
          path: "/customerLogin",
          query: { redirect: this.$route.fullPath },
        });
        return;
      }
      if (this.replyId == id) {
        this.replyId = -1;
      } else {
        this.replyId = id;
        this.sgL_Mem_Cid = sgL_Mem_Cid;
      }
    },
  },
};
</script>

<style scoped>
.flex-container1 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}
.flex-container1 div {
  margin: 5px 0px 2px 5px;
}
.flex-container2 {
  display: flex;
  flex-direction: column;
  flex: 1;
}
.flex-container2 div {
  margin: 5px 0px 2px 5px;
}

.noLogin {
  text-align: center;
  font-size: 12px;
}
.userName {
  font-size: 16px;
  font-weight: bold;
  color: #999;
}
.userContent {
  font-size: 14px;
  line-height: 20px;
}
.userReply {
  font-size: 14px;
}
img {
  width: 60px;
  height: 60px;
  max-width: initial;
}
</style>


// WEBPACK FOOTER //
// src/components/common/userComments.vue